<!--
 * @Author: your name
 * @Date: 2020-09-28 19:29:53
 * @LastEditTime: 2020-11-25 16:32:03
 * @LastEditors: Zed
 * @Description: In User Settings Edit
 * @FilePath: \bidding-oa-web\src\views\components\resultTable.vue
-->
<template>
  <div style="height:90vh;">
    <!-- <el-table :data="list" :show-header="!hideHeader" style="width: 100%" @row-click="onInfo"> -->
    <el-table
      :data="detaList"
      :show-header="!hideHeader"
      style="width: 100%"
      @row-click="onInfo"
    >
      <el-table-column :show-overflow-tooltip="true" label="标题" prop="title">
        <template slot-scope="scope">
          <a href="javascript:;" class="sucess">{{ scope.row.title }}</a>
        </template>
      </el-table-column>
      <!-- <el-table-column :show-overflow-tooltip="true" label="摘要" prop="summary" v-if="!hideHeader">
          <template slot-scope="scope">
            <a href="javascript:;" class='sucess'>{{ scope.row.summary }}</a>
          </template>
        </el-table-column> -->
      <el-table-column
        :show-overflow-tooltip="true"
        label="创建日期"
        prop="createTime"
        width="180"
      >
        <template slot-scope="scope">
          <div class="release-time">{{ scope.row.createTime }}</div>
        </template>
      </el-table-column>

      <el-table-column :show-overflow-tooltip="true" label="" width="180">
        <template slot-scope="scope">
          <el-button type="success" @click="goToHelpDetail(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
        <el-empty description="暂无数据" />
      </div>
    </el-table>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="query.page"
      :page-sizes="[10, 20, 30, 40,50,100]"
      :page-size="query.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>


     <!-- 沟通弹窗 -->
     <el-dialog 
     center 
     title="在线沟通" 
     :visible.sync="connectModal" 
     width="900px" 
     :before-close="detailHandleClose">
       
       <div  ref="connectRef" class="connectClass">
         <div class="father">
             <div v-for="(item,index) in chatList" :key="item.id" 
               class="connectItem" 
               :style="{float: item.type==2?'left':'right','text-align':item.type==2?'left':'right'}">
                 <div style="padding-bottom: 5px;">
                   {{item.senderName}} {{item.createTime}}
                 </div>
                 <div :class="['infoClass',item.type==2?'backgroundEdeded':'']">
                     <span v-if="item.msgType==1" style="text-align: left !important ;float: left; ">
                         {{item.content}}
                     </span>
                     <img width="100px" v-if="item.msgType==2" :src="item.content" style="text-align: left !important ;float: left; " />
                     <video width="300px" v-if="item.msgType==3" :src="item.content"></video>
                  </div>
             </div>
         </div>
     </div>
     <el-input
       type="textarea"
       style=" box-shadow: 15px 0px 10px -15px  #ccc;"
       :autosize="{ minRows: 2, maxRows: 4}"
       placeholder="请输入内容"
       v-model="chatSaveObj.content">
     </el-input>
     <div style="margin-top: 10px;">
       <el-upload
           :action="files"
           :limit="1"
           :auto-upload="true"
           :file-list="fileList"
           :before-upload="beforeAvatarUpload"
           :on-success="(res, file, fileList) => uploadFileSuccess(res, file, fileList)">
           <el-button  size="medium" type="primary">文件上传</el-button>
         </el-upload>
       </div>
     
     <div slot="footer" class="dialog-footer">
       <el-button @click="connectModal = false">取 消</el-button>
       <el-button type="primary" @click="okChatSave(0)">发送</el-button>
     </div>
   </el-dialog>


    <el-button
    type="primary"
      size="large"
      style="position: fixed;right: 20px;bottom: 120px;z-index: 999;" 
      @click="connectModalClick">沟通</el-button>
  </div>
</template>

<script>
import home from "@/api/home";
import req from "@/api/config/config";
import socketApi from '@/utils/socket.js'
export default {
  props: {
    list: Array,
    hideHeader: Boolean,
  },
  created() {
    this.helpCenterPage();
    // console.log(this.list);
    this.userInfo=JSON.parse(localStorage.getItem("userInfo"))
    if(this.userInfo.id){
      socketApi.initWebSocket(this.getMasg)
    }
  },
  data() {
    return {
      detaList: [],
      total: "",
      query: {
        page: 1,
        limit: 10,
        projectId: "",
      },
      userInfo:'',
      connectModal:false,
      files: req.systemIp + '/sysFileInfo/upload',
      fileList:[],
      chatPageObj:{//消息获取
        limit:10,
        page:1
      },
      chatSaveObj:{
        content:'',
        msgType:1//1=文本 2=图片 3=视频
      },
      chatList:[],
      chatListTotal:0
    };
  },
  methods: {
    connectModalClick(){
      this.chatPageObj.page=1
      this.chatPageObj.limit=999999
      this.chatSaveObj.msgType=1
      this.chatList=[]
      this.connectModal=true
      this.$nextTick(() => {
          this.handlerNodeScroll()
          this.getChatPage()
          
        })
    },
    detailHandleClose(){
      this.chatSaveObj.msgType=1
      this.connectModal=false
    },
    getMasg(data){
        let dataJson=JSON.parse(data)
        console.log("提示",dataJson)
        if(dataJson.type==3){
          this.$message({
            showClose: true,
            message: '你有新的在线沟通消息',
            type: 'success'
          }); 
        }

    },
    uploadFileSuccess(res, file, fileList) {
      this.okChatSave({
        ...this.chatSaveObj,
        content:res.data.filePath
      })
      this.fileList=[]
    },
    okChatSave(data){
      // if(this.chatSaveObj.content.indexOf('https://www.zyzhjcxgpt.com/oss/')==-1){//文字
      //   this.chatSaveObj.msgType=1
      // }
      let needData={}
      if(data){

        needData={...data}
      }else{
        this.chatSaveObj.msgType=1
        if(!this.chatSaveObj.content || (this.chatSaveObj.content.trim())==''){
          this.$message({
            showClose: true,
            message: '请输入消息内容',
            type: 'warning'
          });
          return
        }
        needData={...this.chatSaveObj}
      }
      
      home.chatSave(needData).then((res)=>{
        this.chatSaveObj.content=''
        this.getChatPage(1)
        
      })
    },
    //获取消息列表
    getChatPage(index){
      this.chatPageObj.specialistUserId=this.activeSpecialUserId
      if(index==1){//代表发送消息后接收消息
        this.chatPageObj.page==this.chatPageObj.page-1
        this.chatPageObj.limit=10
        this.chatList= this.chatList.slice(0, (this.chatPageObj.page-1)*(this.chatPageObj.limit))
      }
      home.chatPage(this.chatPageObj).then(res=>{
        console.log("获取消息列表",res)
        
        this.chatList=this.chatList.concat(res.data.list)
        this.chatListTotal=res.data.count

        if(index!=1){//首次进来
          this.chatPageObj.page=Math.ceil(res.data.count/10)
        }
        setTimeout(()=>{
          this.$refs.connectRef.scrollTop =this.$refs.connectRef.scrollHeight
        },500)
      })
    },
    handlerNodeScroll(){
      let debounceFunc= this.debounce(e => {
        // 距顶部
        // console.log('ffffffffffff');
        let scrollTop = e.target.scrollTop;
        // 可视区高度
        let clientHeight = e.target.clientHeight;
        // 滚动条总高度
        let scrollHeight = e.target.scrollHeight;
        // 如果当前距离顶部的值加上可视区域的值大于等于总高度，则任务滚动条触底
        if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {   //容差：20px
            console.log('滚动到底部');
            if(this.chatPageObj.page*this.chatPageObj.limit<=this.chatListTotal){
                this.chatPageObj.page++
                this.getChatPage()
            }
        }
      },500)

      // 监听滚动
      this.$refs.connectRef.addEventListener("scroll",  (e)=> {
          debounceFunc(e)
      })
    },
    beforeAvatarUpload(file){
      console.log('文件类型',file.type)
      if(file.type.includes('image')){
        this.chatSaveObj.msgType=2
      }else{
        this.chatSaveObj.msgType=3
      }
      return true
    },
    debounce(handle, delay){
      let timer = null;
      return function () {
        let _self = this,
          _args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          handle.apply(_self, _args)
        }, delay)
      }
    },
    onInfo(row) {
      // window.open(row.projectResultBulletinUrl)
    },
    helpCenterPage() {
      home.helpCenterPage(this.query).then((res) => {
        console.log("获取帮助中心列表", res);
        this.detaList = res.data.list;
        this.total=res.data.count;
      });
    },
    goToHelpDetail(dataId) {
      this.$router.push(`/helpDetail?id=${dataId}`);
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.query.limit=val
        this.helpCenterPage()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.query.page=val
        this.helpCenterPage()
      },
  },
};
</script>

<style lang="less" scoped>
.release-time {
  color: #999999;
}

.sucess {
  color: #131313;
  text-decoration: none;
  cursor: pointer;
  margin: 0;
}

.el-pagination {
  text-align: center;
  margin-top: 20px;
}

/deep/.el-button--small {
  padding: 0;
}

.connectClass{
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    height: 300px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    
    /* background: red; */

  .father:after{
      content: "";
      display: block;
      height: 0;
      clear:both;
      visibility: hidden;
  }
  .father{
      zoom: 1;
    /*IE6清除浮动的方式 只有IE6-IE7执行，其他浏览器不执行*/
  }
    .connectItem{
      overflow: hidden;
      width: 100%;
      .backgroundEdeded{
          background: #ededed !important;
      }
      .infoClass{
        background: #94eb6c;
        display: inline-block;
        width: auto;
        max-width: 40%;
        padding: 10px;
        border-radius: 10px;
      }
    }
  }
</style>
